module.exports = __webpack_public_path__ + "static/media/cd-loading.1cc37f4e.gif";